var activeTeaserBox,
	abo_info_sidebar_content;

function createRadio(data, place, abo) {
	var radioButton =
		$('<label>')
			.addClass("container-radiobutton showAsBlock")
			.text(data.name)
			.append(
				$('<input>')
					.attr('type', 'radio')
					.attr('data-abo-type', data.name)
					.val(data.slug),
				$('<span>').addClass('checkmark')
			);

	if (place === 'abo') {
		radioButton.addClass('container-radiobutton--abo');
		radioButton.find('input').attr('name', 'abo-variante');
	}

	if (place === 'duration') {
		radioButton.addClass('container-radiobutton--duration');
		radioButton.find('input').attr('name', 'abo-variante-duration');

		radioButton.on('change', function () {
			updateAboText($(this).find('input').val(), abo.slug);
			updateSideBar($(this).find('input').val(), abo.name);
			updateShippmentRadio();

			if (data.nurDE) {
				$('.selectbox-country').prop("disabled", true).val('DE').trigger('change');
				$('input[name=region]').val('DE');
				$('input[value=Rechnung]').parent().show();
			} else {
				$('.selectbox-country').prop("disabled", false).val("").trigger('change');
				$('input[value=Rechnung]').parent().hide();
				$('.container-payment-sepa').children().first().find('input').prop('checked', true).trigger('change');
			}
		});
	}

	return radioButton;
}

function createShippmentRadio(data, int) {
	var mwsT = '';

	if (int) {
		mwsT = " € (exkl. MwSt.)";
	} else {
		mwsT = " € (inkl. MwSt.)";
	}

	var radioButton =
		$('<label>')
			.addClass("container-radiobutton showAsBlock")
			.text(data.name + " " + data.gesamtpreis + mwsT)
			.append(
				$('<input>')
					.attr('type', 'radio')
					.val(data.name)
					.attr('data-price', data.gesamtpreis),
				$('<span>').addClass('checkmark')
			);

	radioButton.addClass('container-radiobutton--shipping-cost');
	radioButton.find('input').attr('name', 'shipping-cost');
	return radioButton;
}

function createSidebar(data, aboName) {
	var abosideBar =
		$('<div>')
			.addClass('abo-info-sidebar')
			.append(
				$('<div>')
					.addClass('infoSidebarBoxAbo active')
					.attr('data', data.name)
					.append(
						$('<h4>')
							.addClass('headline-h4')
							.text(aboName),
						$('<p>')
							.addClass('subheadline')
							.text(data.kurzinfo),
						$('<img>')
							.attr('src', data.bild)
							.attr('alt', ''),
						$('<hr>'),
						$('<div>')
							.addClass('price-wrapper')
							.append(
								$('<p>')
									.addClass('spartext')
									.text('Gesamtpreis'),
								$('<p>')
									.addClass('spartext-wrapper')
									.append(
										$('<span>')
											.addClass('spartext-preis')
											.text(data.preis)
											.append(
												$('<span>').text('€')
											)
									)
							)
					)
			);

	if(data.gutschein) {
		abosideBar.append(
			$('<div>')
				.addClass('infoSidebarBoxGutschein active')
				.attr('data', data.name)
				.append(
					$('<p>')
						.addClass('bonustext')
						.append(
							$('<i>')
								.addClass('fa fa-plus'),
							data.gutschein.text
						),
					$('<img>')
						.attr('src', data.gutschein.bild)
						.attr('alt', ''),
					$('<hr>')
				)
		);
	}
	return abosideBar;
}

function updateDurationRadio(data) {
	var durationRadio = $('#checkout-form .abo-form-duration');
	durationRadio.empty();
	data.zeitraeume.forEach(function (zeitraum) {
		durationRadio.append(createRadio(zeitraum, 'duration', data));
	});
	durationRadio.children().first().find('input').prop('checked', true).trigger('change');
}

function updateShippmentRadio() {
	var shippingRadio = $('#checkout-form .abo-form-shipping-cost');
	var aboType = $('#checkout-form input[name=abo-variante]:checked').prop('value');
	var durationType = $('#checkout-form input[name=abo-variante-duration]:checked').prop('value');
	var regionType = ' ';
	var cbLieferadresse = $('#checkout-form input[name=abweichende_lieferadresse]');

	if (cbLieferadresse.is(':checked') || cbLieferadresse.is(':hidden')) {
		regionType = $('#checkout-form select[name=lieferadresse_main-country]').find(':selected').data('region');
	} else {
		regionType = $('#checkout-form select[name=main-country]').find(':selected').data('region');
	}

	shippingRadio.empty();

	if (regionType === ' ') {

	} else {
		aboData.forEach(function (abo) {
			if(abo.slug === aboType) {
				abo.zeitraeume.forEach(function (zeitraum) {
					if ( zeitraum.slug === durationType) {
						if( regionType === 'DE' ) {
							zeitraum.regionen.de.versandarten.forEach(function (versand) {
								shippingRadio.append(createShippmentRadio(versand));
							});
						} else if (regionType === 'EU') {
							zeitraum.regionen.eu.versandarten.forEach(function (versand) {
								shippingRadio.append(createShippmentRadio(versand));
							});
						} else {
							zeitraum.regionen.international.versandarten.forEach(function (versand) {
								shippingRadio.append(createShippmentRadio(versand, true));
							});
						}
					}
				});
			}
		});
	}

	shippingRadio.children('label').each(function () {
		$(this).find('input').on('change', function () {
			$('input[name=trx_amount]').prop('value', $(this).data('price').replace(',', ''));
			$('.spartext-preis').text($(this).data('price')).append($('<span>').text('€'));
		});
	});

	shippingRadio.children().first().find('input').prop('checked', true).trigger('change');
}

function updateSideBar(data, aboName) {
	var sidebar = $('.abo-info-sidebar-wrapper');
	sidebar.empty();

	aboData.forEach(function (abo) {
		if (abo.name === aboName){
			abo.zeitraeume.forEach(function (zeitraum) {
				if (zeitraum.slug === data) {
					sidebar.append(createSidebar(zeitraum, aboName));
				}
			});
		}
	});
}

function updateAboText(data, aboSlug) {
	aboData.forEach(function (abo) {
		if (abo.slug === aboSlug) {
			abo.zeitraeume.forEach(function (zeitraum) {
				if (zeitraum.slug === data) {
					$('#checkout-form .abo-form-text').text(zeitraum.infotext);
				}
			});
		}
	});
}

function updateForm(trigger) {
	var aboSlug = trigger.find('input').val();

	aboData.forEach(function (abo) {
		if (abo.slug === aboSlug) {
			var checkboxButton = $('input[name=abweichende_lieferadresse]');
			var checkbox = $('#checkbox_abweichende_lieferadresse');
			var headline = $('#headline_abweichende_lieferadresse');

			if (abo.lieferadresse_required) {
				headline.show();
				checkbox.hide();
			} else {
				headline.hide();
				checkbox.show();
			}

			checkboxButton.trigger("change");
			updateDurationRadio(abo);
		}
	});
}

function createForm() {
	var aboRadios = $('#checkout-form .abo-form-type');

	aboData.forEach(function (abo) {
		aboRadios.append(createRadio(abo, 'abo'));
	});

	aboRadios.children().first().find('input').prop('checked', true).trigger('change');
	updateDurationRadio(aboData[0]);

}

function changeAboContent(abo, box, slide) {
	var currentAbo = abo.split(" ")[0],
		currentAboDuration = abo.split(" ")[1];

	if (slide) {
		$('html, body').animate({
			scrollTop: $(box).offset().top
		}, 500);
	}
	$('#checkout-form .abo-form-type').children().each( function () {
		if( $(this).find('input').val() === currentAbo) {
			$(this).trigger('click');
			if(typeof currentAboDuration !== 'undefined' ) {
				$('.abo-form-duration').children().each(function () {
					if( $(this).find('input').val() === currentAboDuration) {
						$(this).trigger('click');
					}
				});
			}
		}
	});
}

function toggleNewContactForm(show) {
	var secondAddre = $('#checkout-form .wrapper--second-address');
	var innerContact = secondAddre.find('.formular-kontaktdaten');
	if (show) {
		innerContact.first().slideDown();
		innerContact.find('[data-required=true]').each(function(i, el) {
			$(el).attr('required', '');
		})
	} else {
		innerContact.first().slideUp();
		innerContact.find('[data-required=true]').each(function(i, el) {
			$(el).removeAttr('required');
		})
	}
}

function togglePayment( el ) {
	var txt = el.val();
	var payments = $('.container-payment-sepa');
	var sepaCheck = $('.container-checkbox.sepa');

	if (txt === 'Bankeinzug') {
		payments.slideDown();
		sepaCheck.find('input').attr('required', '');
		sepaCheck.show();
		for(i = 0; i < payments.find('input').length; i++) {
			$(payments.find('input')[i]).attr('required', '');
		}
	} else {
		payments.slideUp();
		sepaCheck.find('input').removeAttr('required');
		sepaCheck.hide();
		for(i = 0; i < payments.find('input').length; i++) {
			$(payments.find('input')[i]).removeAttr('required');
		}
	}

}

function init_abo_bestell_formular() {
	if(typeof aboData !== "undefined"){
		createForm();
		$('input[value=Rechnung]').parent().hide();
		$( "#date-picker" ).hide();

		var paymentRadioButton = document.querySelectorAll('label.container-radiobutton--payment input'),
			checkboxButton = $('input[name=abweichende_lieferadresse]'),
			shippingDate = $('.abo-form-delivery'),
			aboRadioButton = $('.container-radiobutton--abo');

		if($('input[name=user-agent]').length > 0){
			$('input[name=user-agent]').val(navigator.userAgent);
		}

		if (aboRadioButton.length >= 1) {
			for (var i = 0; i < aboRadioButton.length; i++) {
				$(aboRadioButton[i]).on('change', function () {
					updateForm($(this));
				});
			}
		}

		if(paymentRadioButton.length >= 1) {
			$(paymentRadioButton).first().trigger('click')
			for(k = 0; k < paymentRadioButton.length; k++ ) {
				paymentRadioButton[k].addEventListener('change', function () {
					togglePayment($(this));
				});
			}
		}

		if(shippingDate.length >= 1) {
			$(shippingDate.find('input')[0]).trigger('click');
		}

		checkboxButton.prop('checked', false);

		checkboxButton.on('change', function () {
			toggleNewContactForm($(this).is(":checked") || $(this).is(":hidden"));
			updateShippmentRadio();
		});

		shippingDate.children().each(function () {
			$(this).find('input').on('change', function () {
				if ($(this).val() === 'wunschtermin'){
					$( "#date-picker" ).attr('required', '').show();
				} else {
					$( "#date-picker" ).removeAttr('required').hide();
				}
			});
		});

		$('#checkout-form .selectbox-country').on('change', function () {
			var inputRechnung = $('#checkout-form input[value=Rechnung]');
			$('#checkout-form input[name=region]').val($(this).find(':selected').data('region'));
			if ($(this).find(':selected').data('region') === 'DE') {
				inputRechnung.parent().show();
			} else {
				inputRechnung.parent().hide();
				if(inputRechnung.prop('checked')){
					$(paymentRadioButton[0]).trigger('click');
				}
			}
			updateShippmentRadio();
		});

		$('#checkout-form').on("validation-complete", function (event, validationResult) {
			if (validationResult.isValid) {
				var $form = $(this);
				var formData = $form.serializeArray();
				var name = $('#checkout-form input[name=Vorname]').prop('value').concat(' ', $('#checkout-form input[name=Nachname]').prop('value'));
				var ipaymentHintClass = "ipayment-hint-shown";
				$('#checkout-form input[value=ECM]').prop('disabled', true);

				formData.forEach(function (data) {
					if(data.name === 'zahlungsart' && data.value.match('Kreditkarte|PayPal')) {
						if (!$form.hasClass(ipaymentHintClass)) {
							$form.addClass(ipaymentHintClass);
							validationResult.originalEvent.preventDefault();
							$('#checkout-form input[name=addr_name]').attr('value', name);
							$('#checkout-form').attr('action', 'https://ipayment.de/merchant/72272084/processor/2.0/');
							if( data.value.match('Kreditkarte')) {
								$('#checkout-form input[name=trx_paymenttyp]').val('cc');
							} else {
								$('#checkout-form input[name=trx_paymenttyp]').val('paypal');
								$('#checkout-form input[value=ECM]').prop('disabled', false);
								$('#checkout-form input[name=return_paymentdata_details]').prop('disabled', false);
							}
							// Show payment hint popup which can not be closed
							window.openPopUpOverlay('ipayment-hint');
							$("#pop-up-overlay .close-overlay").remove();
						} else {
							$form.removeClass(ipaymentHintClass);
						}
					}
				});
			}
		});

		$("#ipayment-hint-submit").on('submit', function (e) {
			e.preventDefault();
			$('#checkout-form').submit();
		})

		if ($('input[name=zahlungsart]:checked').val() !== "Bankeinzug") {
			$('.container-checkbox.sepa').hide();
		}
	}
}

init_abo_bestell_formular();
